import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import { isNull as _isNull } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import styles from '../styles';

const getAdditionalStyle = (
  isFirstTab,
  isLastTab,
  isActiveTab,
  stylesParam,
  tabContainerStyle,
  theme,
) => {
  const { tab, middle, last, active } = stylesParam;
  const style = [tab(theme)];
  if (isActiveTab) {
    style.push(active(theme));
  }
  if (!isFirstTab && !isLastTab) {
    style.push(middle);
  }
  if (isLastTab) {
    style.push(last);
  }
  if (!_isNull(tabContainerStyle)) {
    style.push(tabContainerStyle);
  }
  return style;
};
function CustomTab({
  children,
  handelOnPress,
  isFirstTab,
  isLastTab,
  isActiveTab,
  style,
  textStyle,
  theme,
}) {
  return (
    <TouchableWithoutFeedback onPress={handelOnPress} testID={FrameworkTestKeys.customTabContainer}>
      <View
        style={getAdditionalStyle(isFirstTab, isLastTab, isActiveTab, styles, style, theme)}
        testID={FrameworkTestKeys.customTabViewContainer}
      >
        <VFText
          type={isActiveTab ? 'secondary' : 'primary'}
          i18nKey={children}
          style={[styles.title, textStyle]}
          testKey={FrameworkTestKeys.customTabText}
        />
      </View>
    </TouchableWithoutFeedback>
  );
}

CustomTab.defaultProps = {
  theme: LightThemeColors,
};

CustomTab.propTypes = {
  children: PropTypes.node.isRequired,
  handelOnPress: PropTypes.func.isRequired,
  theme: PropTypes.object,
  style: ViewPropTypes.style,
  isFirstTab: PropTypes.bool.isRequired,
  isLastTab: PropTypes.bool.isRequired,
  isActiveTab: PropTypes.bool.isRequired,
  textStyle: TextPropTypes.style,
};

export { getAdditionalStyle };

export default CustomTab;
